// app/javascript/controllers/coaches_for_subject_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["subjectSelect"];

  reloadCoachSelect(event) {
    const subjectId = event.target.value;
    if (!subjectId) return;
    const frame = document.querySelector("turbo-frame#coach_select_frame");
    if (frame) {
      frame.src = `/corrections/coach_select?subject_id=${subjectId}`;
    }
  }
}
